import { Resume } from 'packages/types'
import { useI18n } from 'builder/hooks/useI18n'
import { SpacingChangeHandler } from 'builder/modules/resumeEditor'
import { useTextCustomization } from '../../hooks/useTextCustomization'
import { GenericRelativeSlider } from './GenericRelativeSlider'

type Props = {
  resume: Resume
  handleSpacingChange?: SpacingChangeHandler
}

export const SpacingSlider = (props: Props) => {
  const { resume, handleSpacingChange } = props
  const { supportsSpacing, spacing } = useTextCustomization(resume)
  const { i18n } = useI18n()

  const onChange = (value: number | number[]) => {
    const newValue = Array.isArray(value) ? value[0] : value
    handleSpacingChange?.(newValue, spacing)
  }

  return (
    <GenericRelativeSlider
      value={spacing}
      onChange={onChange}
      disabledTooltip={i18n.t(
        'builder.resume_editor.document_customization.sidebar.text_tab.spacing_customization_warning',
      )}
      testId="spacing-slider-container"
      isDisabled={!supportsSpacing || !handleSpacingChange}
      readableStep={25}
    />
  )
}
